module.exports = __webpack_public_path__ + "img/NC.ba08bc66.svg";